import { baseApi } from "./apiConfig";

export const isValidSession = async () => {
  try {
    const timeStamp = new Date().getTime();
    const response = await baseApi.get(
      `/portal/is-valid-session`,
      {
        params: {
          timeStamp,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("api isValidSession error:", error);
    throw error;
  }
};